import { Printer } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useImpressaoExpedicao } from '@/hooks/useImpressaoExpedicao';

/**
 * Aviso no cabeçalho quando a etiqueta de expedição PAROU de sair.
 *
 * Funcionando, a impressão é invisível — o operador fatura e a etiqueta sai,
 * sem ícone nem barulho. Só quando algo a impede (servidor fora, trava de
 * escrita, o crachá imprimindo em outro computador) aparece aqui, porque etiqueta que não sai trava a expedição e
 * ninguém percebe olhando a tela de faturamento.
 */
export function AvisoImpressao(): JSX.Element | null {
  const { estado } = useImpressaoExpedicao();
  const navegar = useNavigate();
  if (estado.tipo !== 'erro' && estado.tipo !== 'outro_computador') return null;

  return (
    <button
      type="button"
      onClick={() => navegar('/impressao-etiquetas')}
      title={estado.mensagem}
      className="flex h-10 items-center gap-1.5 rounded-lg bg-status-divergenciaFundo px-2.5 text-[12px] font-semibold text-status-divergencia"
    >
      <Printer className="h-[18px] w-[18px]" />
      <span className="hidden sm:inline">
        {estado.tipo === 'outro_computador' ? 'Etiquetas em outro computador' : 'Etiquetas paradas'}
      </span>
    </button>
  );
}
